import { useCallback } from 'react'

/**
 * @describe - Custom hook for handling menu click and keyboard events
 */
export default function useMenuEventHandlers(callback) {
  const handleMenuEvent = useCallback(
    (event) => {
      if (!callback) return

      const leftMouseButton = event.button === 0
      const enterOrSpaceKey = [13, 32].includes(event.keyCode)

      if (leftMouseButton || enterOrSpaceKey) {
        callback(event)
      }
    },
    [callback]
  )

  return { handleMenuEvent }
}
